<template>
  <b-modal id="showModal" v-model="showModal" size="xl" no-close-on-backdrop no-close-on-esc>
    <div slot="modal-header" class="w-100">
      <span class="pl-2" style="font-size: 20px">Plsease confirm</span>
    </div>
    <div class="w-100" style="padding: 0 10px 10px">
      <span>{{ text }}</span>
    </div>
    <div slot="modal-footer" class="w-40">
      <b-btn type="submit" variant="success" style="margin-right: 20px" @click="yes">Yes</b-btn>
      <b-btn class="float-right" variant="danger" @click="no">No</b-btn>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: {
    showModal: {
      default: false,
      type: Boolean
    },
    discardModal: {
      default: false,
      type: Boolean
    },
    yes: {
      default: () => {},
      type: Function
    },
    no: {
      default: () => {},
      type: Function
    },
    text: {
      default: '',
      type: String
    }
  }
};
</script>

<style>
</style>
